import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Container from '../container';
import MenuButton from './MenuButton';
import { getClassName } from '../../../utils/ui/classes';
const Navbar = ({ showLeftMenuToggle, mainNavOpen, children, renderRightNav, renderMobileNav, logo, onToggleOpen, }) => {
    const [open, setOpen] = useState(false);
    function toggleOpen() {
        setOpen(!open);
    }
    return (React.createElement("nav", { className: "fixed top-0 left-0 z-50 w-full bg-gray-800" },
        React.createElement(Container, null,
            React.createElement("div", { className: "flex items-center justify-between w-full h-16" },
                React.createElement("div", { className: "flex items-center" },
                    showLeftMenuToggle && (React.createElement("div", { className: "hidden lg:block" },
                        React.createElement(MenuButton, { open: mainNavOpen, onClick: onToggleOpen }))),
                    React.createElement("div", { className: "flex-shrink-0" }, logo),
                    React.createElement("div", { className: "hidden lg:ml-4 xl:ml-6 lg:block" },
                        React.createElement("div", { className: "relative flex space-x-4" }, children))),
                React.createElement("div", { className: "hidden lg:ml-6 lg:block" },
                    React.createElement("div", { className: "flex items-center" }, renderRightNav())),
                React.createElement("div", { className: "flex lg:hidden" },
                    React.createElement(MenuButton, { open: open, onClick: toggleOpen }))),
            React.createElement("div", { className: getClassName('lg:hidden', { block: open, hidden: !open }) }, renderMobileNav(toggleOpen)))));
};
Navbar.propTypes = {
    showLeftMenuToggle: PropTypes.bool,
    children: PropTypes.any,
    renderRightNav: PropTypes.func,
    renderMobileNav: PropTypes.func,
};
Navbar.defaultProps = {
    showLeftMenuToggle: false,
    renderRightNav: () => { },
    renderMobileNav: () => { },
};
export default Navbar;
